import { BASE_API_URL_V2 } from "../../../constants";
import fpFetch from "../../../services/fpFetch";

export interface FileMove {
  file_id: string;
  new_name?: string; // For rename operations
}

export interface FolderMove {
  path: string[];
  new_name?: string; // For rename operations
}

export interface MoveItemsRequest {
  files?: FileMove[];
  folders?: FolderMove[];
  target_path: string[];
  drive_id?: string;
}

export interface MoveItemsResponse {
  files_moved: number;
  folders_moved: number;
}

/**
 * Move files and folders to a target location using unified endpoint.
 * All moves happen in a single transaction.
 * Supports renaming files and folders via the new_name field.
 */
const moveItems = async (
  request: MoveItemsRequest
): Promise<MoveItemsResponse> => {
  const response = await fpFetch(`${BASE_API_URL_V2}/api/v2/users/files/move`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      files: request.files ?? [],
      folders: request.folders ?? [],
      target_path: request.target_path,
      drive_id: request.drive_id,
    }),
  });
  return response.json();
};

export default moveItems;
